<div *ngIf="errorMessage != null">
  <span class="glyphicon glyphicon-remove form-control-feedback"></span>
  <span class="sr-only">(error)</span>
  <div class="alert alert-danger errorDiv" role="alert">
    {{ errorMessage }}
  </div>
</div>
